<template>
  <div class="app-box">
    <div class="box">
        <h3>VIP视频解析说明</h3>
        <p>操作指南</p>
        <p class="text1">第一步进入各大视频网站，找到想要观看的VIP视频(例如：爱奇艺、优酷、乐视、芒果、搜狐、腾讯好莱坞),然后复制链接</p>
        <p class="text1">第二步将复制的链接粘贴到本站播放地址，并点击开始解析</p>
        <p class="text1">第三步等待解析完成，即可免费观看VIP视频</p>
        <p class="text1">第四步注意事项：全网VIP电影免费看，若遇到不能播放，确保视频地址无误后，请更换播放引擎多点击几次“开始解析”</p>
        <h1>在下方输入框输入视频地址点解析播放即可</h1>
        <div class="srsarr">
          <a href="http://wpa.qq.com/msgrd?v=3&amp;uin=964502906&amp;site=qq&amp;menu=yes" target="_blank" class="iconfont textP icon---" title="点我">
          无法播放，我要反馈，侵权我要反馈点我
          </a>
        </div>

    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>
  .app-box{
    height: 95vh;
    overflow: hidden;
  }
  .app-box .box{
    background: #ecf5ff;
    min-height: 100%;
    overflow: hidden;
    padding: 15px;
  }
  body{
    margin: 0;
    line-height: 15px;
  }
  h1{
    text-align: center;
    line-height: 27px;
  }
  h3,p{
    text-align: center;
    font-size: 18px;
  }
  .text1{
    font-size: 15px;
    color: #606266;
    margin-bottom: 40px;
    line-height: 18px;
  }
  .text2{
    color: #000;
  }
  .textP{
    text-align: center;
    font-size: 20px;
    margin: auto;
  }
  .srsarr{
    width: 100%;
    text-align: center;
    margin-top:50px;
  }
</style>